import WorkoutRest from './WorkoutRest';

export default WorkoutRest;
